/* eslint-disable */

import React, { Component, Fragment } from 'react'
import Button from '@material-ui/core/Button'
import { withApollo } from 'react-apollo'
import Grid from '@material-ui/core/Grid'
import {
  Card,
  CardContent,
  Divider,
  Switch,
  Typography
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import withSharedSnackbar from '../../HOCs/withSharedSnackbar'
import Select from 'react-select'
import axios from 'axios'
import getLoginId from '../../../utils/getLoginId'
import FormControl from '@material-ui/core/FormControl'
import FileSaver from 'file-saver'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormLabel from '@material-ui/core/FormLabel'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Multiselect from 'multiselect-react-dropdown'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@material-ui/core'
import {
  ADD_VEHICLES,
  GET_ALL_VEHICLES,
  GET_CALIBRATION_DETAILS,
  GET_FILE_FORMAT,
  GET_FUEL_SENSOR_ASSIGNMENTS,
  GET_FUEL_SENSOR_DETAILS,
  GET_PARTNER_CLIENT_LIST,
  GET_UPLOAD_URL
} from '../../../queries'
import TankCard from './TankCard'
import TankConfigHeader from './TankConfigHeader'

const style = theme => ({
  root: {
    padding: theme.spacing.unit * 4,
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary
  },
  iconSmall: {
    fontSize: 20
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit
  },
  dense: {
    marginTop: 16
  }
})

class FuelCalibration extends Component {
  // Multi-tank configuration handlers
  handleTankDataChange = (tankIndex, field, value) => {
    this.setState(prevState => {
      const updatedTanks = [...prevState.tanks]
      const actualIndex = tankIndex - 3 // tank 3 = index 0
      updatedTanks[actualIndex] = {
        ...updatedTanks[actualIndex],
        [field]: value
      }
      // Validation
      if (field === 'minCapacity') {
        const regex = new RegExp(/^[0-9]{1,3}$/)
        updatedTanks[actualIndex].isMinCapacityValid =
          regex.test(value) || value === ''
      } else if (field === 'maxCapacity') {
        const regex = new RegExp(/^[0-9]{2,5}$/)
        updatedTanks[actualIndex].isMaxCapacityValid =
          regex.test(value) || value === ''
      } else if (field === 'totalFuelTank') {
        const regex = new RegExp(/^[0-9]{2,5}$/)
        updatedTanks[actualIndex].isTotalFuelTankValid =
          regex.test(value) || value === ''
      }
      return { tanks: updatedTanks }
    })
  }

  handleAddTank = () => {
    this.setState(prevState => ({
      tanks: [
        ...prevState.tanks,
        {
          tankNumber: prevState.tanks.length + 3,
          minValue: '',
          maxValue: '',
          minCapacity: '',
          maxCapacity: '',
          totalFuelTank: '',
          isMinCapacityValid: true,
          isMaxCapacityValid: true,
          isTotalFuelTankValid: true,
          fileName: '',
          bucketName: '',
          downloadUrl: '',
          isUploading: false
        }
      ]
    }))
  }

  handleRemoveTank = tankIndex => {
    this.setState(prevState => {
      const actualIndex = tankIndex - 3
      const updatedTanks = prevState.tanks.filter(
        (_, idx) => idx !== actualIndex
      )
      // Reassign tank numbers
      const reNumbered = updatedTanks.map((tank, idx) => ({
        ...tank,
        tankNumber: idx + 3
      }))
      return { tanks: reNumbered }
    })
  }

  handleTankFileUpload = async (tankIndex, file) => {
    this.setState(prevState => {
      const updatedTanks = [...prevState.tanks]
      const actualIndex = tankIndex - 3
      updatedTanks[actualIndex] = {
        ...updatedTanks[actualIndex],
        isUploading: true
      }
      return { tanks: updatedTanks }
    })

    try {
      const fileExtension = file.name.split('.').pop()
      const { client } = this.props
      const { data } = await client.mutate({
        mutation: GET_UPLOAD_URL,
        variables: { fileExtension }
      })
      const { bucketName, filename, publicUploadURL } = data.getPublicUploadURL
      await axios.put(publicUploadURL, file, {
        headers: { 
          // 'Content-Type': file.type,
          "x-ms-blob-type": "BlockBlob",
          "Content-Type": file.type || "application/octet-stream" 
        }
      })
      const result = await client.query({
        query: GET_FILE_FORMAT,
        variables: { bucketname: bucketName, filename },
        errorPolicy: 'all'
      })
      this.setState(prevState => {
        const updatedTanks = [...prevState.tanks]
        const actualIndex = tankIndex - 3
        updatedTanks[actualIndex] = {
          ...updatedTanks[actualIndex],
          fileName: filename,
          bucketName: bucketName,
          downloadUrl: result.data.getPublicDownloadURL,
          isUploading: false
        }
        return { tanks: updatedTanks }
      })
      if (this.props.handleSnackbar) {
        this.props.handleSnackbar({
          message: 'File uploaded successfully',
          severity: 'success'
        })
      }
    } catch (error) {
      this.setState(prevState => {
        const updatedTanks = [...prevState.tanks]
        const actualIndex = tankIndex - 3
        updatedTanks[actualIndex] = {
          ...updatedTanks[actualIndex],
          isUploading: false
        }
        return { tanks: updatedTanks }
      })
      if (this.props.handleSnackbar) {
        this.props.handleSnackbar({
          message: 'Failed to upload file',
          severity: 'error'
        })
      }
    }
  }

  handlePrimaryTankChange = (index, field, value) => {
    this.setState({ [field]: value }, () => {
      if (field === 'minCapacity') this.checkMinCapacityValidity()
      if (field === 'maxCapacity') this.checkMaxCapacityValidity()
      if (field === 'totalFuelTank') this.checkTotalFuelTankValidity()
      if (field === 'minValue') this.checkMinValueValidity()
      if (field === 'maxValue') this.checkMaxValueValidity()
    })
  }

  handlePrimaryTankFileUpload = async (tankIndex, file) => {
    this.setState({ isUploading: true })
    try {
      const fileExtension = file.name.split('.').pop()
      const { client } = this.props
      const { data } = await client.mutate({
        mutation: GET_UPLOAD_URL,
        variables: { fileExtension }
      })
      const { bucketName, filename, publicUploadURL } = data.getPublicUploadURL
      console.log("Uploading to URL with headers: ", publicUploadURL, {
        // 'Content-Type': file.type,
        "x-ms-blob-type": "BlockBlob",
        "Content-Type": file.type || "application/octet-stream"
      })
      await axios.put(publicUploadURL, file, {
        headers: { 
          'Content-Type': file.type,
          "x-ms-blob-type": "BlockBlob",
          "Content-Type": file.type || "application/octet-stream" 
        }
      })
      const result = await client.query({
        query: GET_FILE_FORMAT,
        variables: { bucketname: bucketName, filename },
        errorPolicy: 'all'
      })
      this.setState({
        fileName: filename,
        bucketName: bucketName,
        downloadUrl: result.data.getPublicDownloadURL,
        isUploading: false
      })
      if (this.props.handleSnackbar) {
        this.props.handleSnackbar({
          message: 'File uploaded successfully',
          severity: 'success'
        })
      }
    } catch (error) {
      this.setState({ isUploading: false })
      if (this.props.handleSnackbar) {
        this.props.handleSnackbar({
          message: 'Failed to upload file',
          severity: 'error'
        })
      }
    }
  }

  handleSecondaryTankChange = (index, field, value) => {
    const stateFieldMap = {
      minValue: 'secondaryTankMinValue',
      maxValue: 'secondaryTankMaxValue',
      minCapacity: 'secondaryTankMinCapacity',
      maxCapacity: 'secondaryTankMaxCapacity',
      totalFuelTank: 'secondaryTankTotalFuelTank'
    }
    const stateField = stateFieldMap[field]
    if (stateField) {
      this.setState({ [stateField]: value }, () => {
        if (field === 'minCapacity')
          this.checkSecondaryTankMinCapacityValidity()
        if (field === 'maxCapacity')
          this.checkSecondaryTankMaxCapacityValidity()
        if (field === 'totalFuelTank')
          this.checkSecondaryTankTotalFuelTankValidity()
        if (field === 'minValue') this.checkSecondaryTankMinValueValidity()
        if (field === 'maxValue') this.checkSecondaryTankMaxValueValidity()
      })
    }
  }

  handleSecondaryTankFileUpload = async (tankIndex, file) => {
    this.setState({ isUploadingSecondary: true })
    try {
      const fileExtension = file.name.split('.').pop()
      const { client } = this.props
      const { data } = await client.mutate({
        mutation: GET_UPLOAD_URL,
        variables: { fileExtension }
      })
      const { bucketName, filename, publicUploadURL } = data.getPublicUploadURL
      await axios.put(publicUploadURL, file, {
        headers: { 
          // 'Content-Type': file.type,
          "x-ms-blob-type": "BlockBlob",
          "Content-Type": file.type || "application/octet-stream" 
        }
      })
      const result = await client.query({
        query: GET_FILE_FORMAT,
        variables: { bucketname: bucketName, filename },
        errorPolicy: 'all'
      })
      this.setState({
        secondaryFileName: filename,
        secondaryBucketName: bucketName,
        secondaryDownloadUrl: result.data.getPublicDownloadURL,
        isUploadingSecondary: false
      })
      if (this.props.handleSnackbar) {
        this.props.handleSnackbar({
          message: 'File uploaded successfully',
          severity: 'success'
        })
      }
    } catch (error) {
      this.setState({ isUploadingSecondary: false })
      if (this.props.handleSnackbar) {
        this.props.handleSnackbar({
          message: 'Failed to upload file',
          severity: 'error'
        })
      }
    }
  }

  areDynamicTanksInvalid = () => {
    if (this.state.hasSecondaryTank && this.state.showMultiTankConfig) {
      return this.state.tanks.some(
        tank =>
          tank.minValue === '' ||
          tank.maxValue === '' ||
          tank.minCapacity === '' ||
          tank.maxCapacity === '' ||
          tank.totalFuelTank === '' ||
          tank.fileName === ''
      )
    }
    return false
  }
  state = {
    // Multi-tank feature flag
    multiTankConfigV2: true, // Set to true to enable new multi-tank config
    showMultiTankConfig: false,
    // Multi-tank configuration state (tanks 3 onwards)
    tanks: [
      {
        tankNumber: 3,
        minValue: '',
        maxValue: '',
        minCapacity: '',
        maxCapacity: '',
        totalFuelTank: '',
        isMinCapacityValid: true,
        isMaxCapacityValid: true,
        isTotalFuelTankValid: true,
        fileName: '',
        bucketName: '',
        downloadUrl: '',
        isUploading: false
      }
    ],
    availableDataTypes: [],
    fuelSensorDetails: [],
    selectedFuelSensors: [],
    allFuelSensorAssignments: [],
    selectedIMEIs: {},
    preferedDataType: null,
    // fuelSensorName: '',
    fuelSensorNames: [],
    availableDataTypeOptions: [],
    preferedDataTypeOptions: [],
    client: { value: null, label: null },
    isUploading: false,
    fileName: '',
    bucketName: '',
    publicUploadURL: '',
    response: '',
    uploadSucess: true,
    result: false,
    errorMessage: false,
    failList: '',
    isLoading: false,

    response: '',
    clientNames: [],
    clientname: '',
    vehicleDetails: [],
    vehicleNumber: '',
    minValue: '',
    maxValue: '',
    minCapacity: '',
    maxCapacity: '',
    totalFuelTank: '',
    sensorType: '',
    isminCapacityValid: true,
    ismaxCapacityValid: true,
    isTotalFuelTankValid: true,
    isminValueValid: true,
    ismaxValueValid: true,

    //secondary tank
    isUploadingSecondary: false,
    secondaryFileName: '',
    hasSecondaryTank: false,
    hasInSameTank: false,
    isDualSensor: false,
    secondaryBucketName: '',
    secondaryPublicUploadURL: '',
    secondaryDownloadUrl: '',
    secondaryTankMinValue: '',
    secondaryTankMaxValue: '',
    secondaryTankMinCapacity: '',
    secondaryTankMaxCapacity: '',
    secondaryTankTotalFuelTank: '',
    secondaryTankSensorType: 'Digital_sensor',
    isMinSecondaryTankCapacityValid: true,
    isMaxSecondaryTankCapacityValid: true,
    isSecondaryTotalFuelTankValid: true,
    isMinSecondaryTankValueValid: true,
    isMaxSecondaryTankValueValid: true,
    calibrationDataExists: false,
    pilferageTolerance: '10',
    // minimumPilferageDuration: '30',
    userType: '0',
    downloadUrl: '',
    useTaabiAlgo: false,
    resetKey: 0
  }

  handleClientChange = async event => {
    this.resetFields()
    if (event && event.value) {
      this.setState({ clientname: event ? event.value : '' })
      const {
        data: vehicle,
        error: vehicleError
      } = await this.props.client.query({
        query: GET_ALL_VEHICLES,
        variables: { clientLoginId: event ? event.value : '' },
        errorPolicy: 'all',
        fetchPolicy: 'network-only'
      })
      const allVehicles = vehicle.getAllVehicleDetails.map(vehicle => ({
        value: vehicle.entityId,
        label: vehicle.vehicleNumber
      }))
      if (vehicleError) {
        this.setState({ vehicleDetails: [] })
      } else {
        this.setState({ vehicleDetails: allVehicles })
      }
    } else {
      // Clear all fields if vehicle field is cleared
      this.setState({ clientname: '' })
      this.setState({ vehicleDetails: [] })
      this.resetFields()
    }
  }

  handleChange = async event => {
    if (event && event.value) {
      const vehicleNumber = event.value

      const { data } = await this.props.client.query({
        query: GET_CALIBRATION_DETAILS,
        variables: {
          entityId: parseInt(vehicleNumber, 10)
        },
        fetchPolicy: 'network-only'
      })

      if (data.getFuelCalibrationDetail) {
        // If vehicle is in the database, set the vehicle number and details
        this.setState({
          vehicleNumber,
          calibrationDataExists: true
        })
        // this.setState({ fuelSensorNames: [] });
        this.setDetails(data.getFuelCalibrationDetail)
      } else {
        // If vehicle is not in the database, reset all fields except the vehicle number
        this.resetFields()
        // Set the vehicle number without clearing it from the input field
        this.setState({
          vehicleNumber,
          calibrationDataExists: false
        })
      }
    } else {
      // Clear all fields if vehicle field is cleared
      this.resetFields()
      this.setState({ calibrationDataExists: false })
    }
  }

  resetFields() {
    // Reset multi-tank config
    this.setState({
      tanks: [
        {
          tankNumber: 3,
          minValue: '',
          maxValue: '',
          minCapacity: '',
          maxCapacity: '',
          totalFuelTank: '',
          isMinCapacityValid: true,
          isMaxCapacityValid: true,
          isTotalFuelTankValid: true,
          fileName: '',
          bucketName: '',
          downloadUrl: '',
          isUploading: false
        }
      ],
      showMultiTankConfig: false,
      refuelThreshold: '3',
      vehicleNumber: '',
      drainThreshold: '0.5',
      medianFilter: '10',
      pfPerMin: '3',
      pilferageTolerance: '10',
      minimumPilferageDuration: '30',
      userType: '0',
      sensorType: '',
      minValue: '',
      maxValue: '',
      minCapacity: '',
      maxCapacity: '',
      totalFuelTank: '',
      fileName: '',

      bucketName: '',
      publicUploadURL: '',
      downloadUrl: '',
      overallThreshold: '',
      // secondary tank
      hasSecondaryTank: false,
      hasInSameTank: false,
      isDualSensor: false,
      secondaryTankMinCapacity: '',
      secondaryTankMaxCapacity: '',
      secondaryTankTotalFuelTank: '',
      secondaryTankMinValue: '',
      secondaryTankMaxValue: '',
      secondaryFileName: '',
      secondaryBucketName: '',
      secondaryPublicUploadURL: '',
      secondaryDownloadUrl: '',
      useTaabiAlgo: false,
      useObdAlgo: '',
      availableDataTypes: [],
      fuelSensorNames: [],
      selectedFuelSensors: [],
      selectedIMEIs: {},
      // fuelSensorDetails: [],
      preferedDataType: null,
      // fuelSensorName: '',
      fuelSensorAlgo: '',
      calibrationDataExists: false
    })
    this.setState(prevState => ({
      resetKey: prevState.resetKey + 1
    }))
  }

  setDetails = vehicleDetail => {
    console.log('details', vehicleDetail)
    let fileName = ''
    let bucketName = ''
    let url = ''

    let secondaryFileName = ''
    let secondaryBucketName = ''
    let secondaryUrl = ''

    if (
      vehicleDetail.calibration_filename !== null ||
      vehicleDetail.calibration_filename !== undefined
    ) {
      fileName = vehicleDetail.calibration_filename
      bucketName = 'aquila-track-uploads'
    }

    if (
      vehicleDetail.secondary_tank_calibration_filename !== null ||
      vehicleDetail.secondary_tank_calibration_filename !== undefined
    ) {
      secondaryFileName = vehicleDetail.secondary_tank_calibration_filename
      secondaryBucketName = 'aquila-track-uploads'
    }

    if (vehicleDetail.url !== null || vehicleDetail.url !== undefined) {
      url = vehicleDetail.url
    }
    if (
      vehicleDetail.secondaryUrl !== null ||
      vehicleDetail.secondaryUrl !== undefined
    ) {
      secondaryUrl = vehicleDetail.secondaryUrl
    }
    if (
      vehicleDetail.fuelSensorNames &&
      vehicleDetail.fuelSensorNames.length &&
      vehicleDetail.fuelSensorIMEIs &&
      vehicleDetail.fuelSensorIMEIs.length
    ) {
      let incomingUUIDs = vehicleDetail.fuelSensorIMEIs
      let selectedFuelSensorIds = vehicleDetail.fuelSensorNames
      const selectedIMEIs = {}
      selectedFuelSensorIds.forEach((sensorId, index) => {
        const uuid = incomingUUIDs[index]
        if (uuid) {
          const matchedIMEI = this.state.allFuelSensorAssignments.find(
            item => item.uuid === uuid
          )
          if (matchedIMEI) {
            selectedIMEIs[matchedIMEI.fuelSensorId] = {
              value: matchedIMEI.uuid,
              label: matchedIMEI.imeiNumber
            }
          }
        }
      })
      this.setState({
        selectedFuelSensors: selectedFuelSensorIds,
        selectedIMEIs
      })
    } else {
      this.setState({
        selectedFuelSensors: [],
        selectedIMEIs: {}
      })
    }

    // Multi-tank config: set tanks and showMultiTankConfig from API response
    if (
      vehicleDetail.tanks &&
      Array.isArray(vehicleDetail.tanks) &&
      vehicleDetail.tanks.length > 0
    ) {
      const additionalTanks = vehicleDetail.tanks.map(tank => ({
        tankNumber: tank.tankNumber,
        minValue:
          tank.minValue !== undefined && tank.minValue !== null
            ? tank.minValue
            : '',
        maxValue:
          tank.maxValue !== undefined && tank.maxValue !== null
            ? tank.maxValue
            : '',
        minCapacity:
          tank.minTankCapacity !== undefined && tank.minTankCapacity !== null
            ? tank.minTankCapacity
            : '',
        maxCapacity:
          tank.maxTankCapacity !== undefined && tank.maxTankCapacity !== null
            ? tank.maxTankCapacity
            : '',
        totalFuelTank:
          tank.totalFuelTank !== undefined && tank.totalFuelTank !== null
            ? tank.totalFuelTank
            : '',
        isMinCapacityValid: true,
        isMaxCapacityValid: true,
        isTotalFuelTankValid: true,
        fileName: tank.calibration_filename || '',
        bucketName: tank.bucketName || '',
        downloadUrl: tank.url || '',
        isUploading: false
      }))
      this.setState({
        tanks: additionalTanks,
        showMultiTankConfig: true
      })
    } else {
      this.setState({
        tanks: [
          {
            tankNumber: 3,
            minValue: '',
            maxValue: '',
            minCapacity: '',
            maxCapacity: '',
            totalFuelTank: '',
            isMinCapacityValid: true,
            isMaxCapacityValid: true,
            isTotalFuelTankValid: true,
            fileName: '',
            bucketName: '',
            downloadUrl: '',
            isUploading: false
          }
        ],
        showMultiTankConfig: false
      })
    }
    // ...existing code...
    this.setState({
      pilferageTolerance: vehicleDetail.pilferageTolerance,
      // minimumPilferageDuration: vehicleDetail.minimumPilferageDuration,
      userType: JSON.stringify(vehicleDetail.fuelUserType),
      sensorType: vehicleDetail.fuelSensorType,
      minValue: vehicleDetail.minValue,
      maxValue: vehicleDetail.maxValue,
      // overallThreshold: vehicleDetail.overallThreshold,
      minCapacity: vehicleDetail.minTankCapacity,
      maxCapacity: vehicleDetail.maxTankCapacity,
      totalFuelTank: vehicleDetail.totalFuelTank,
      fileName: fileName,
      bucketName: bucketName,
      publicUploadURL: url,
      downloadUrl: url,
      // secondary tank
      hasSecondaryTank: !!vehicleDetail.hasSecondaryTank,
      hasInSameTank: !!vehicleDetail.hasInSameTank,
      isDualSensor: !!vehicleDetail.isDualSensor,
      // fuelSensorAlgo: vehicleDetail.fuelSensorAlgo || null,
      useTaabiAlgo: vehicleDetail.useTaabiAlgo || null,
      // useObdAlgo: vehicleDetail.obdAlgo || null,
      availableDataTypes: vehicleDetail.availableDataTypes || [],
      fuelSensorNames: vehicleDetail.fuelSensorNames || [],
      preferedDataType: vehicleDetail.preferedDataType || null,
      // fuelSensorName: vehicleDetail.fuelSensorName || null,
      secondaryTankMinCapacity:
        vehicleDetail.secondaryTankMinCapacity === 0
          ? '0'
          : vehicleDetail.secondaryTankMinCapacity || '',
      secondaryTankMaxCapacity: vehicleDetail.secondaryTankMaxCapacity || '',
      secondaryTankTotalFuelTank: vehicleDetail.secondaryTankTotalFuel || '',
      secondaryTankMinValue:
        vehicleDetail.secondaryTankMinValue === 0
          ? '0'
          : vehicleDetail.secondaryTankMinValue || '',
      secondaryTankMaxValue: vehicleDetail.secondaryTankMaxValue || '',
      secondaryFileName: secondaryFileName || '',
      secondaryBucketName: secondaryBucketName || '',
      secondaryPublicUploadURL: secondaryUrl || '',
      secondaryDownloadUrl: secondaryUrl || ''
    })
  }
  handleClose = () => {
    this.setState({ result: false })
  }
  handleCloseError = () => {
    this.setState({ errorMessage: false })
  }

  handleInputChange = key => e => {
    const value = e.target.value === '' ? null : e.target.value
    this.setState({ [key]: e.target.value })
  }

  handleChangeType = event => {
    //console.log(event.target.value, 'typ')
    this.setState({ sensorType: event.target.value })
    // console.log(this.state.sensorType, event.target.value, 'typ')
  }

  handleChangeSecondartTankType = event => {
    //console.log(event.target.value, 'typ')
    this.setState({ secondaryTankSensorType: event.target.value })
    // console.log(this.state.sensorType, event.target.value, 'typ')
  }

  handleUserChangeType = event => {
    this.setState({ userType: event.target.value })
    // console.log(this.state.userType, event.target.value, 'typ')
  }

  getClients = async () => {
    let data = await this.props.client.query({
      query: GET_PARTNER_CLIENT_LIST,
      variables: {
        partnerLoginId: getLoginId()
      },
      fetchPolicy: 'network-only'
    })

    const allClients = data.data.clientsDetails.map(client => ({
      value: client.loginId,
      label: client.clientName
    }))
    this.setState({ clientNames: allClients })
  }

  getFuelSensorDetails = async () => {
    let data = await this.props.client.query({
      query: GET_FUEL_SENSOR_DETAILS,
      fetchPolicy: 'network-only'
    })

    const sensorDetails = data.data.getFuelSensorDetails.map(row => ({
      value: row.fuelSensorId,
      label: row.fuelSensorName
    }))
    this.setState({ fuelSensorDetails: sensorDetails })
  }
  getFuelSensorAssignments = async () => {
    try {
      const response = await this.props.client.query({
        query: GET_FUEL_SENSOR_ASSIGNMENTS,
        fetchPolicy: 'network-only'
      })

      this.setState({
        allFuelSensorAssignments: response.data.getFuelSensorAssignments
      })
    } catch (error) {
      console.error('Error fetching fuel sensor assignments:', error)
    }
  }
  getAvailableDataTypesOptions = async () => {
    try {
      let tempData = [
        { value: 1, label: 'digital-sensor-data' },
        { value: 2, label: 'analog-sensor-data' },
        { value: 3, label: 'obd-data' }
      ]
      this.setState({ availableDataTypeOptions: tempData })
    } catch (error) {
      console.log(error, 'API Error')
    }
  }

  validateSecondary = () => {
    let isValid = true
    if (this.state.hasSecondaryTank) {
      if (
        // this.state.hasInSameTank === false ||
        this.state.secondaryTankMinValue === '' ||
        this.state.secondaryTankMinCapacity === '' ||
        this.state.secondaryTankMaxValue === '' ||
        this.state.secondaryTankMaxCapacity === '' ||
        this.state.secondaryTankTotalFuelTank === '' ||
        this.state.secondaryFileName === '' ||
        this.state.secondaryBucketName === '' ||
        this.state.secondaryDownloadUrl === ''
      ) {
        isValid = false
      }
    }

    return isValid
  }

  handleSubmit = async event => {
    console.log(this.state)
    this.setState({ isLoading: true })
    const imeiUUIDs = Object.values(this.state.selectedIMEIs)
      .filter(item => item && item.value)
      .map(item => item.value)

    // Multi-tank payload mapping
    const DYNAMIC_TANK_PAYLOAD_KEYS = {
      tankNumber: 'tankNumber',
      minValue: 'minValue',
      maxValue: 'maxValue',
      minCapacity: 'minTankCapacity',
      maxCapacity: 'maxTankCapacity',
      totalFuelTank: 'totalFuelTank',
      fileName: 'calibration_filename',
      bucketName: 'bucketName'
    }
    const additionalTanks =
      this.state.hasSecondaryTank && this.state.showMultiTankConfig
        ? this.state.tanks.map(tank => ({
            [DYNAMIC_TANK_PAYLOAD_KEYS.tankNumber]: tank.tankNumber,
            [DYNAMIC_TANK_PAYLOAD_KEYS.minValue]: parseInt(tank.minValue, 10),
            [DYNAMIC_TANK_PAYLOAD_KEYS.maxValue]: parseInt(tank.maxValue, 10),
            [DYNAMIC_TANK_PAYLOAD_KEYS.minCapacity]: parseInt(
              tank.minCapacity,
              10
            ),
            [DYNAMIC_TANK_PAYLOAD_KEYS.maxCapacity]: parseInt(
              tank.maxCapacity,
              10
            ),
            [DYNAMIC_TANK_PAYLOAD_KEYS.totalFuelTank]: parseInt(
              tank.totalFuelTank,
              10
            ),
            [DYNAMIC_TANK_PAYLOAD_KEYS.fileName]: tank.fileName,
            [DYNAMIC_TANK_PAYLOAD_KEYS.bucketName]: tank.bucketName
          }))
        : []

    const { data, errors } = await this.props.client.mutate({
      mutation: ADD_VEHICLES,
      variables: {
        fileInfo: {
          uploadFor: 'uploadFileToFuelCalibrationTable',
          bucketName: this.state.bucketName,
          fileName: this.state.fileName,
          operationType: 'SKIP'
        },
        secondaryFileInfo: {
          uploadFor: 'uploadFileToFuelCalibrationTable',
          bucketName: this.state.secondaryBucketName,
          fileName: this.state.secondaryFileName,
          operationType: 'SKIP'
        },
        commonInput: {
          clientLoginId: parseInt(this.state.clientname, 10),
          //partnerLoginId: getLoginId(),
          // manufacturerCode: this.state.manufacturer.code
          fuelInputs: {
            vehicleId: parseInt(this.state.vehicleNumber, 10),
            fuelSensorType: this.state.sensorType,
            minTankCapacity: parseInt(this.state.minCapacity, 10),
            minValue: parseInt(this.state.minValue, 10),
            maxTankCapacity: parseInt(this.state.maxCapacity, 10),
            totalFuelTank: parseInt(this.state.totalFuelTank, 10),
            maxValue: parseInt(this.state.maxValue, 10),
            // overallThreshold: parseFloat(this.state.overallThreshold, 10),
            availableDataTypes: this.state.availableDataTypes
              ? this.state.availableDataTypes
              : [],
            preferedDataType: this.state.preferedDataType
              ? this.state.preferedDataType.value
              : null,
            fuelSensorNames: this.state.fuelSensorNames
              ? this.state.fuelSensorNames
              : null,
            fuelSensorIMEIs: imeiUUIDs.length > 0 ? imeiUUIDs : null,
            // secondary tank
            hasSecondaryTank: this.state.hasSecondaryTank,
            hasInSameTank: this.state.hasInSameTank,
            isDualSensor: this.state.isDualSensor,
            useTaabiAlgo: this.state.useTaabiAlgo
              ? this.state.useTaabiAlgo
              : null,
            secondaryTankFuelSensorType: this.state.sensorType,
            secondaryTankMinCapacity: parseInt(
              this.state.secondaryTankMinCapacity,
              10
            ),
            secondaryTankMaxCapacity: parseInt(
              this.state.secondaryTankMaxCapacity,
              10
            ),
            secondaryTankTotalFuel: parseInt(
              this.state.secondaryTankTotalFuelTank,
              10
            ),
            secondaryTankMinValue: parseInt(
              this.state.secondaryTankMinValue,
              10
            ),
            secondaryTankMaxValue: parseInt(
              this.state.secondaryTankMaxValue,
              10
            ),
            fuelUserType: 1,
            pilferageTolerance: parseFloat(this.state.pilferageTolerance, 10)
          }
        },
        // Multi-tank config
        tanks: additionalTanks.length > 0 ? additionalTanks : null
      },
      errorPolicy: 'all'
    })
    this.setState({ isLoading: false })
    if (data) {
      let fullData = []
      let arrList = data.excelFileUpload.failedUploadList
      JSON.parse(arrList).forEach(element => {
        var rowData = []
        rowData.push(element.serialNumber)
        rowData.push(element.error)
        fullData.push(rowData)
      })
      this.setState({
        response:
          'Total Excel Records= ' +
          data.excelFileUpload.totalExcelDataRecords +
          ',' +
          'Total Records Uploaded=' +
          data.excelFileUpload.successfullyUploaded +
          ', Total Records Failed To Upload=' +
          data.excelFileUpload.failedToUpload +
          ', Total Duplicate Records in Excel=' +
          data.excelFileUpload.totalDuplicateRecords,
        uploadSucess: true,
        errorMessage: false,
        failList: fullData,
        result: true
      })
    } else {
      this.setState({
        response: errors[0].message,
        errorMessage: true,
        uploadSucess: true
      })
    }
  }

  checkMinCapacityValidity = () => {
    const regex = new RegExp(/^[0-9]{1,3}$/)
    this.setState({
      isminCapacityValid:
        regex.test(this.state.minCapacity) || this.state.minCapacity === ''
    })
  }
  checkMaxCapacityValidity = () => {
    const regex = new RegExp(/^[0-9]{2,5}$/)
    this.setState({
      ismaxCapacityValid:
        regex.test(this.state.maxCapacity) || this.state.maxCapacity === ''
    })
  }
  checkTotalFuelTankValidity = () => {
    const regex = new RegExp(/^[0-9]{2,5}$/)
    this.setState({
      isTotalFuelTankValid:
        regex.test(this.state.totalFuelTank) || this.state.totalFuelTank === ''
    })
  }

  checkMinValueValidity = () => {
    const regex = new RegExp(/^[0-9]{1,3}$/)
    this.setState({
      isminValueValid:
        regex.test(this.state.minValue) || this.state.minValue === ''
    })
  }
  checkMaxValueValidity = () => {
    const regex = new RegExp(/^[0-9]{2,5}$/)
    this.setState({
      ismaxValueValid:
        regex.test(this.state.maxValue) || this.state.maxValue === ''
    })
  }
  // secondary tank
  checkSecondaryTankMinCapacityValidity = () => {
    const regex = new RegExp(/^[0-9]{1,3}$/)
    this.setState({
      isMinSecondaryTankCapacityValid:
        regex.test(this.state.secondaryTankMinCapacity) ||
        this.state.secondaryTankMinCapacity === ''
    })
  }
  checkSecondaryTankMaxCapacityValidity = () => {
    const regex = new RegExp(/^[0-9]{2,5}$/)
    this.setState({
      isMaxSecondaryTankCapacityValid:
        regex.test(this.state.secondaryTankMaxCapacity) ||
        this.state.secondaryTankMaxCapacity === ''
    })
  }
  checkSecondaryTankTotalFuelTankValidity = () => {
    const regex = new RegExp(/^[0-9]{2,5}$/)
    this.setState({
      isSecondaryTotalFuelTankValid:
        regex.test(this.state.secondaryTankTotalFuelTank) ||
        this.state.secondaryTankTotalFuelTank === ''
    })
  }
  checkSecondaryTankMinValueValidity = () => {
    const regex = new RegExp(/^[0-9]{1,3}$/)
    this.setState({
      isMinSecondaryTankValueValid:
        regex.test(this.state.secondaryTankMinValue) ||
        this.state.secondaryTankMinValue === ''
    })
  }
  checkSecondaryTankMaxValueValidity = () => {
    const regex = new RegExp(/^[0-9]{2,5}$/)
    this.setState({
      isMaxSecondaryTankValueValid:
        regex.test(this.state.secondaryTankMaxValue) ||
        this.state.secondaryTankMaxValue === ''
    })
  }

  componentDidMount() {
    this.getClients(this.props.client)
    this.getFuelSensorAssignments()
    this.getFuelSensorDetails()
    // this.getTaabiOptions()
    // this.getObdOptions()
    this.getAvailableDataTypesOptions()
    // this.getPreferedDataTypesOptions()
  }

  downloadBulkUpload = client => async event => {
    const { data } = await this.props.client.query({
      query: GET_FILE_FORMAT,
      variables: {
        bucketname: 'excel-templates',
        filename: 'Fuelcalibration.xlsx'
      },
      errorPolicy: 'all'
    })
    const res = await axios({
      url: data.getPublicDownloadURL,
      method: 'GET',
      headers: { Accept: 'application/vnd.ms-excel' },
      responseType: 'blob' // important
    })

    FileSaver.saveAs(new Blob([res.data]), 'sample.xlsx')
    // FileSaver.saveAs(data.getPublicDownloadURL, 'sample.xlsx')
  }
  isSelected = optionValue => {
    return this.state.availableDataTypes.includes(optionValue)
  }

  handleAvailableDataTypeChange = selectedDataTypeOption => {
    const selectedValues = selectedDataTypeOption.map(option => option.value)
    this.setState({ availableDataTypes: selectedValues })
  }

  handlefuelSensorNameChange = selectedFuelSensorNames => {
    const fuelSensorNames = selectedFuelSensorNames.map(option => option.value)
    const selectedFuelSensors = [...fuelSensorNames]

    // Reset selected IMEIs for removed fuel sensors
    const selectedIMEIs = Object.keys(this.state.selectedIMEIs)
      .filter(sensorId => selectedFuelSensors.includes(sensorId))
      .reduce((result, sensorId) => {
        result[sensorId] = this.state.selectedIMEIs[sensorId]
        return result
      }, {})

    this.setState({ fuelSensorNames: fuelSensorNames })
    this.setState({
      selectedFuelSensors,
      selectedIMEIs
    })
  }
  handleIMEISelection = (fuelSensorId, imeiUUID) => {
    this.setState(prevState => ({
      selectedIMEIs: {
        ...prevState.selectedIMEIs,
        [fuelSensorId]: imeiUUID
      }
    }))
  }

  getSelectedFuelNames = () => {
    const selectedOptions = this.state.fuelSensorDetails.filter(option =>
      this.state.fuelSensorNames.includes(option.value)
    )
    return selectedOptions
  }

  handlePreferedDataTypeChange = selectedDataTypeOption => {
    this.setState({ preferedDataType: selectedDataTypeOption })
  }

  render() {
    const dataTypeLabels = {
      1: 'Digital Sensor Data',
      2: 'Analog sensor Data',
      3: 'OBD Data'
    }
    const preferedDataTypeOptions = Array.from(
      new Set(this.state.availableDataTypes.flat())
    ).map(value => ({
      label: dataTypeLabels[value],
      value
    }))
    const { classes } = this.props
    // console.log(this.state.clientNames, '///')
    const isFormIncomplete =
      this.state.clientname === '' ||
      this.state.vehicleNumber === '' ||
      this.state.refuelThreshold === '' ||
      this.state.drainThreshold === '' ||
      this.state.medianFilter === '' ||
      this.state.pfPerMin === '' ||
      this.state.pilferageTolerance === '' ||
      this.state.minimumPilferageDuration === '' ||
      this.state.userType === '' ||
      this.state.minValue === '' ||
      this.state.minCapacity === '' ||
      this.state.maxValue === '' ||
      this.state.maxCapacity === '' ||
      this.state.totalFuelTank === '' ||
      this.state.fileName === '' ||
      this.state.bucketName === '' ||
      this.state.downloadUrl === '' ||
      this.state.sensorType === '' ||
      this.state.availableDataTypes.length === 0 ||
      this.getSelectedFuelNames().length === 0 ||
      this.state.preferedDataType === null ||
      // overallThreshold === '' ||
      !this.validateSecondary() ||
      this.areDynamicTanksInvalid()

    return (
      <div className={classes.root}>
        <Typography variant="subtitle1" gutterBottom>
          <h2>Fuel Caliberation</h2>
        </Typography>
        <Grid container spacing={16}>
          <Grid container xs={12}>
            <Grid item xs={6}>
              Available Clients *
              <Grid item xs={12}>
                <FormControl
                  style={{
                    minWidth: '70%'
                  }}
                >
                  <Select
                    classes={classes}
                    options={this.state.clientNames}
                    // components={components}
                    value={this.state.clientname}
                    onChange={this.handleClientChange}
                    placeholder="Select Client *"
                    menuContainerStyle={{ zIndex: 9 }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={8} style={{ marginTop: 10 }}>
                Available Data Types *
                <Multiselect
                  key={this.state.resetKey}
                  displayValue="label"
                  onKeyPressFn={function noRefCheck() {}}
                  onSearch={function noRefCheck() {}}
                  onRemove={
                    this.state.calibrationDataExists
                      ? () => {}
                      : this.handleAvailableDataTypeChange
                  }
                  onSelect={
                    this.state.calibrationDataExists
                      ? () => {}
                      : this.handleAvailableDataTypeChange
                  }
                  selectedValues={this.state.availableDataTypeOptions.filter(
                    option => this.isSelected(option.value)
                  )}
                  onChange={
                    this.state.calibrationDataExists
                      ? () => {}
                      : this.handleAvailableDataTypeChange
                  }
                  options={this.state.availableDataTypeOptions}
                  placeholder={
                    this.state.calibrationDataExists
                      ? 'Cannot edit'
                      : 'select option'
                  }
                  disable={this.state.calibrationDataExists}
                  required
                />
              </Grid>
              <Grid item xs={8} style={{ marginTop: 10 }}>
                Preferred Data Type *
                <div
                  style={{
                    pointerEvents: this.state.calibrationDataExists
                      ? 'none'
                      : 'auto',
                    position: 'relative'
                  }}
                >
                  <Select
                    value={this.state.preferedDataType}
                    onChange={
                      this.state.calibrationDataExists
                        ? () => {}
                        : this.handlePreferedDataTypeChange
                    }
                    options={preferedDataTypeOptions}
                    placeholder={
                      this.state.calibrationDataExists
                        ? 'Cannot edit'
                        : 'select option'
                    }
                    isDisabled={this.state.calibrationDataExists}
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        opacity: state.isDisabled ? 0.6 : 1,
                        pointerEvents: state.isDisabled ? 'none' : 'auto'
                      })
                    }}
                    menuContainerStyle={{ zIndex: 9 }}
                    required
                  />
                </div>
              </Grid>
              <Grid item xs={12}>
                <br />
              </Grid>
            </Grid>
            <Grid item xs={6}>
              Available Vehicles *
              <Grid item xs={12}>
                <FormControl
                  style={{
                    minWidth: '70%'
                  }}
                >
                  <Select
                    classes={classes}
                    options={this.state.vehicleDetails}
                    // components={components}
                    value={this.state.vehicleNumber}
                    onChange={this.handleChange}
                    placeholder="Select Vehicle *"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={8} style={{ marginTop: 10 }}>
                Fuel Sensor Name *
                <Multiselect
                  key={this.state.resetKey}
                  displayValue="label"
                  onKeyPressFn={function noRefCheck() {}}
                  onSearch={function noRefCheck() {}}
                  onRemove={
                    this.state.calibrationDataExists
                      ? () => {}
                      : this.handlefuelSensorNameChange
                  }
                  onSelect={
                    this.state.calibrationDataExists
                      ? () => {}
                      : this.handlefuelSensorNameChange
                  }
                  selectedValues={this.getSelectedFuelNames()}
                  onChange={
                    this.state.calibrationDataExists
                      ? () => {}
                      : this.handlefuelSensorNameChange
                  }
                  options={this.state.fuelSensorDetails}
                  placeholder={
                    this.state.calibrationDataExists
                      ? 'Cannot edit'
                      : 'select option'
                  }
                  disable={this.state.calibrationDataExists}
                  required
                />
              </Grid>
              <Grid item xs={8} style={{ marginTop: 10 }}>
                {this.state.selectedFuelSensors.length > 0 &&
                  `Fuel Sensor IMEI Associations*`}
                {this.state.selectedFuelSensors.length > 0 && (
                  <div
                    style={{
                      border: '1px solid #c9c9c9',
                      padding: '20px',
                      borderRadius: '5px',
                      marginTop: '10px'
                    }}
                  >
                    <Grid container spacing={8}>
                      <Grid item xs={6}>
                        <Typography
                          variant="h6"
                          component="div"
                          style={{
                            fontWeight: 'bold',
                            color: '#3f3f3f',
                            marginBottom: '10px'
                          }}
                        >
                          FUEL SENSOR NAME
                        </Typography>
                      </Grid>
                      <Grid item xs={6} style={{ textAlign: 'right' }}>
                        <Typography
                          variant="h6"
                          component="div"
                          style={{
                            fontWeight: 'bold',
                            color: '#3f3f3f',
                            marginBottom: '10px'
                          }}
                        >
                          IMEI
                        </Typography>
                      </Grid>
                    </Grid>

                    {this.state.selectedFuelSensors.map(sensorId => {
                      const imeiOptions = this.state.allFuelSensorAssignments
                        .filter(
                          item =>
                            item.fuelSensorId === sensorId &&
                            item.status === 'available'
                        )
                        .map(item => ({
                          value: item.uuid,
                          label: item.imeiNumber
                        }))
                      const sensorName =
                        (
                          this.state.fuelSensorDetails.find(
                            item => item.value === sensorId
                          ) || {}
                        ).label || ''

                      return (
                        <Grid
                          container
                          spacing={8}
                          key={sensorId}
                          style={{ marginTop: '10px', alignItems: 'center' }}
                        >
                          <Grid
                            item
                            xs={6}
                            style={{ display: 'flex', alignItems: 'center' }}
                          >
                            <Typography variant="body1">
                              {sensorName}
                            </Typography>
                          </Grid>

                          <Grid item xs={6}>
                            <Select
                              options={imeiOptions}
                              value={this.state.selectedIMEIs[sensorId] || null}
                              onChange={
                                this.state.calibrationDataExists
                                  ? () => {}
                                  : selectedOption =>
                                      this.handleIMEISelection(
                                        sensorId,
                                        selectedOption
                                      )
                              }
                              placeholder={
                                this.state.calibrationDataExists
                                  ? 'Cannot edit'
                                  : 'Select IMEI *'
                              }
                              isClearable
                              disabled={this.state.calibrationDataExists}
                            />
                          </Grid>
                        </Grid>
                      )
                    })}
                  </div>
                )}
              </Grid>
            </Grid>

            <br />
          </Grid>

          <Grid
            container
            alignItems="stretch"
            className="multitank"
            style={{ marginTop: '20px', marginBottom: '20px' }}
          >
            {/* Card 1: Tank & Sensor Configuration */}
            <Grid item xs={12} sm={6} md={4} style={{ paddingRight: '16px' }}>
              <Card
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%',
                  backgroundColor: '#f8f8f8'
                }}
              >
                <CardContent style={{ flexGrow: 1 }}>
                  <Typography
                    variant="h6"
                    component="h2"
                    style={{ fontWeight: 'bold' }}
                  >
                    Tank Configuration
                  </Typography>
                  <Typography color="textSecondary" gutterBottom>
                    Manage secondary tank and sensor settings.
                  </Typography>
                  <Divider style={{ margin: '8px 0' }} />
                  <Grid container alignItems="center" justify="space-between">
                    <Grid item>
                      <Typography>Secondary Tank Available</Typography>
                    </Grid>
                    <Grid item>
                      <Switch
                        checked={this.state.hasSecondaryTank}
                        onChange={() => {
                          if (!this.state.calibrationDataExists) {
                            const nextHasSecondary = !this.state
                              .hasSecondaryTank
                            this.setState({
                              hasSecondaryTank: nextHasSecondary,
                              // Reset multi-tank config when disabling secondary
                              showMultiTankConfig: nextHasSecondary
                                ? false
                                : false,
                              hasInSameTank: nextHasSecondary
                                ? this.state.hasInSameTank
                                : false
                            })
                          }
                        }}
                        disabled={this.state.calibrationDataExists}
                        title={
                          this.state.calibrationDataExists
                            ? 'Cannot modify when calibration data exists'
                            : ''
                        }
                      />
                    </Grid>
                  </Grid>

                  {this.state.hasSecondaryTank && (
                    <Grid
                      container
                      alignItems="center"
                      justify="space-between"
                      style={{ marginTop: '8px' }}
                    >
                      <Grid item>
                        <Typography>Is In SameTank</Typography>
                      </Grid>
                      <Grid item>
                        <Switch
                          checked={this.state.hasInSameTank}
                          onChange={() => {
                            if (!this.state.calibrationDataExists) {
                              this.setState({
                                hasInSameTank: !this.state.hasInSameTank
                              })
                            }
                          }}
                          disabled={this.state.calibrationDataExists}
                        />
                      </Grid>
                    </Grid>
                  )}

                  {this.state.hasSecondaryTank && (
                    <Grid
                      container
                      alignItems="center"
                      justify="space-between"
                      style={{ marginTop: '8px' }}
                    >
                      <Grid item>
                        <Typography>
                          Multi-Tank Configuration Available
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Switch
                          checked={this.state.showMultiTankConfig}
                          onChange={() => {
                            if (!this.state.calibrationDataExists) {
                              this.setState({
                                showMultiTankConfig: !this.state
                                  .showMultiTankConfig
                              })
                            }
                          }}
                          disabled={this.state.calibrationDataExists}
                          title={
                            this.state.calibrationDataExists
                              ? 'Cannot modify when calibration data exists'
                              : ''
                          }
                        />
                      </Grid>
                    </Grid>
                  )}
                </CardContent>
              </Card>
            </Grid>

            {/* Card 2: Fuel Sensor Type */}
            <Grid item xs={12} sm={6} md={4} style={{ paddingRight: '16px' }}>
              <Card
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%',
                  backgroundColor: '#f8f8f8'
                }}
              >
                <CardContent style={{ flexGrow: 1 }}>
                  <Typography
                    variant="h6"
                    component="h2"
                    style={{ fontWeight: 'bold' }}
                  >
                    Sensor Type
                  </Typography>
                  <Typography color="textSecondary" gutterBottom>
                    Select the appropriate fuel sensor type.
                  </Typography>
                  <Divider style={{ margin: '8px 0' }} />
                  <FormControl
                    component="fieldset"
                    disabled={this.state.calibrationDataExists}
                  >
                    <FormLabel component="legend">Fuel Sensor Type:*</FormLabel>
                    <RadioGroup
                      aria-label="sensorType"
                      name="sensorType"
                      value={this.state.sensorType}
                      onChange={this.handleChangeType}
                      row
                    >
                      <FormControlLabel
                        value="Digital_sensor"
                        control={<Radio />}
                        label="Digital Sensor"
                      />
                      <FormControlLabel
                        value="Analog_sensor"
                        control={<Radio />}
                        label="Analog Sensor"
                      />
                    </RadioGroup>
                  </FormControl>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    style={{ marginTop: '8px', display: 'block' }}
                  >
                    *Cannot change if calibration data exists.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            {/* Card 3: Calibration Data Management */}
            <Grid item xs={12} sm={6} md={4}>
              <Card
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%',
                  backgroundColor: '#f8f8f8'
                }}
              >
                <CardContent
                  style={{
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                >
                  <Typography
                    variant="h6"
                    component="h2"
                    style={{ fontWeight: 'bold' }}
                  >
                    Calibration Data
                  </Typography>
                  <Typography color="textSecondary" gutterBottom>
                    Download sample to generate a fuel calibration equation.
                  </Typography>
                  <Divider style={{ margin: '8px 0' }} />
                  <div
                    style={{
                      flexGrow: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <Button
                      color="secondary"
                      variant="contained"
                      onClick={this.downloadBulkUpload(this.props.client)}
                      style={{ width: 'auto' }}
                    >
                      Download Sample Excel
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          {/* _________________________________________________ */}
          <TankConfigHeader
            title="Primary and Secondary Tank Configuration"
            description="Set up and manage your primary and secondary fuel tanks. To configure the secondary tank, first enable the 'Secondary Tank Available' toggle under Tank Configuration."
            gradientType="primary"
          />

          <div
            style={{
              justifyContent: 'space-around',
              alignItems: 'center',
              display: 'flex',
              gap: '50px',
              flexWrap: 'wrap'
            }}
          >
            <TankCard
              tankIndex={1}
              title="Primary Tank"
              tankData={{
                minValue: this.state.minValue,
                maxValue: this.state.maxValue,
                minCapacity: this.state.minCapacity,
                maxCapacity: this.state.maxCapacity,
                totalFuelTank: this.state.totalFuelTank,
                isMinCapacityValid: this.state.isminCapacityValid,
                isMaxCapacityValid: this.state.ismaxCapacityValid,
                isTotalFuelTankValid: this.state.isTotalFuelTankValid
              }}
              onTankDataChange={this.handlePrimaryTankChange}
              onFileUpload={this.handlePrimaryTankFileUpload}
              isUploading={this.state.isUploading}
              fileName={this.state.fileName}
              downloadUrl={this.state.downloadUrl}
              disabled={this.state.calibrationDataExists}
              showDeleteButton={false}
            />

            {this.state.hasSecondaryTank && (
              <TankCard
                tankIndex={2}
                title="Secondary Tank"
                tankData={{
                  minValue: this.state.secondaryTankMinValue,
                  maxValue: this.state.secondaryTankMaxValue,
                  minCapacity: this.state.secondaryTankMinCapacity,
                  maxCapacity: this.state.secondaryTankMaxCapacity,
                  totalFuelTank: this.state.secondaryTankTotalFuelTank,
                  isMinCapacityValid: this.state
                    .isMinSecondaryTankCapacityValid,
                  isMaxCapacityValid: this.state
                    .isMaxSecondaryTankCapacityValid,
                  isTotalFuelTankValid: this.state.isSecondaryTotalFuelTankValid
                }}
                onTankDataChange={this.handleSecondaryTankChange}
                onFileUpload={this.handleSecondaryTankFileUpload}
                isUploading={this.state.isUploadingSecondary}
                fileName={this.state.secondaryFileName}
                downloadUrl={this.state.secondaryDownloadUrl}
                disabled={this.state.calibrationDataExists}
                showDeleteButton={false}
              />
            )}
          </div>
          {/* Multi-Tank Configuration UI - Additional Tanks (Tank 3 onwards) */}
          {this.state.hasSecondaryTank &&
            this.state.showMultiTankConfig && (
              <React.Fragment>
                <TankConfigHeader />

                {/* Additional Tank Cards Container - 3x3 Grid */}
                <Grid item xs={12} style={{ marginBottom: 24 }}>
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(3, 1fr)',
                      gridGap: '14px'
                    }}
                  >
                    {this.state.tanks.map((tank, index) => (
                      <TankCard
                        tankIndex={tank.tankNumber}
                        tankData={tank}
                        onTankDataChange={this.handleTankDataChange}
                        onRemoveTank={this.handleRemoveTank}
                        onFileUpload={this.handleTankFileUpload}
                        isUploading={tank.isUploading}
                        fileName={tank.fileName}
                        downloadUrl={tank.downloadUrl}
                        disabled={
                          (this.state.selectedCurClientsVehicleValue
                            ? this.state.selectedCurClientsVehicleValue
                                .length === 0
                            : false) ||
                          (this.state.curClientVehicles
                            ? this.state.curClientVehicles.length === 0
                            : false) ||
                          this.state.calibrationDataExists
                        }
                        permissions={this.state.permissions}
                        userId={this.state.userId}
                      />
                    ))}
                  </div>
                </Grid>

                {/* Add Tank Button */}
                <Grid item xs={12} marginBottom={3}>
                  <Button
                    variant="contained"
                    onClick={this.handleAddTank}
                    disabled={this.state.calibrationDataExists}
                    sx={{
                      backgroundColor: '#1b9cd5',
                      color: 'white',
                      px: 3,
                      py: 1.5,
                      borderRadius: 2,
                      textTransform: 'none',
                      fontSize: '1rem',
                      fontWeight: 600,

                      boxShadow: '0 4px 12px rgba(27, 156, 213, 0.3)',
                      '&:hover': {
                        backgroundColor: '#137aa1',
                        boxShadow: '0 6px 16px rgba(27, 156, 213, 0.4)',
                        transform: 'translateY(-1px)'
                      },
                      transition: 'all 0.3s ease'
                    }}
                  >
                    + Add Tank
                  </Button>
                </Grid>
              </React.Fragment>
            )}

          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={this.handleSubmit}
              disabled={
                isFormIncomplete ||
                this.state.calibrationDataExists ||
                this.state.selectedFuelSensors.some(
                  sensorId => !this.state.selectedIMEIs[sensorId]
                )
              }
            >
              Submit
            </Button>{' '}
            <Button
              color="default"
              variant="outlined"
              size="medium"
              margin="normal"
              className="btn"
              onClick={() => this.props.history.goBack()}
            >
              Cancel
            </Button>
          </Grid>
          <Grid item xs={12}>
            {this.state.result === true && (
              <Dialog open={true}>
                <DialogTitle>Alert</DialogTitle>
                <DialogContent>
                  <Typography variant="subtitle1" gutterBottom>
                    Data has been saved successfully.
                  </Typography>
                </DialogContent>
                <DialogActions>
                  <Button onClick={this.handleClose} color="primary">
                    Close
                  </Button>
                </DialogActions>
              </Dialog>
            )}
            {this.state.errorMessage && (
              <Dialog open={true}>
                <DialogTitle>Alert</DialogTitle>
                <DialogContent>
                  <Typography variant="subtitle1" gutterBottom>
                    {this.state.response ===
                    'Something went wrong please check the file header name'
                      ? 'Check the fuel calibration file uploaded'
                      : this.state.response}
                  </Typography>
                </DialogContent>
                <DialogActions>
                  <Button onClick={this.handleCloseError} color="primary">
                    Close
                  </Button>
                </DialogActions>
              </Dialog>
            )}
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default withStyles(style)(
  withApollo(withSharedSnackbar(FuelCalibration))
)



// WEBPACK FOOTER //
// ./src/components/Pages/FuelCalibration/index.jsx